import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Cotisation, Document, Insured, Share } from 'src/app/models/models';
import { AuthService } from 'src/app/services/auth.service';
import { PopulationService } from 'src/app/services/population.service';
import { DocumentService } from '../../services/document.service';
import { ModalService } from '../../services/modal.service';
import {
  LoadingController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { ShareService } from 'src/app/services/share.service';

@Component({
  selector: 'app-member-modal',
  templateUrl: './member-modal.component.html',
  styleUrls: ['./member-modal.component.scss'],
})
export class MemberModalComponent implements OnInit {
  @Input() member: Insured;
  @Input() tab: 'contract' | 'informations' | 'documents' = 'contract';
  contractForm: FormGroup;
  informationsForm: FormGroup;
  shares: Share[];
  beneficiaries: Insured[] = [];
  cotisations: Cotisation[] = [];
  env = environment;
  canShowBeneficiaires = false;

  constructor(
    private formBuilder: FormBuilder,
    private populationService: PopulationService,
    public authService: AuthService,
    public documentService: DocumentService,
    private modalService: ModalService,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private shareService: ShareService,
    private navCtrl: NavController,
  ) {}

  ngOnInit() {
    this.authService.user.subscribe((user) => {
      if (!user) {
        this.close();
      } else {
        this.init();
      }
    });
  }

  async init() {
    Promise.all([
      this.shareService.getInsuredShares(this.member.id),
      this.populationService.getMemberDetails(this.member.id),
    ]).then(([shares, memberDetails]) => {
      this.member.lastAccess = memberDetails.lastAccess;
      this.shares = shares;
      this.beneficiaries = memberDetails.beneficiaries;
      this.canShowBeneficiaires =
        memberDetails.canShowBeneficiaires &&
        this.env.config?.memberDetails?.showBeneficiaires;
      this.cotisations = memberDetails.cotisations;
      this.contractForm = this.formBuilder.group({
        regime: new FormControl(memberDetails?.contract?.name, [
          Validators.required,
        ]),
        startDate: new FormControl(memberDetails?.contract?.startDate, [
          Validators.required,
        ]),
        endDate: new FormControl(memberDetails?.contract?.endDate, [
          Validators.required,
        ]),
        state: new FormControl(memberDetails?.contract?.state, [
          Validators.required,
        ]),
        cpam: new FormControl(this.member?.attachment?.caisse, [
          Validators.required,
        ]),
        // employerPart: new FormControl(null, [Validators.required]),
        // employeePart: new FormControl(null, [Validators.required])
      });
      this.informationsForm = this.formBuilder.group({
        socialSecurityNumber: new FormControl(
          this.member?.insee + '' + this.member?.inseeKey,
          [Validators.required]
        ),
        birthdate: new FormControl(this.member?.birthdate, [
          Validators.required,
        ]),
        mail: new FormControl(memberDetails?.contact?.mail, [
          Validators.required,
        ]),
        phone: new FormControl(memberDetails?.contact?.phone, [
          Validators.required,
        ]),
        mobile: new FormControl(memberDetails?.contact?.mobile, []),
        street: new FormControl(memberDetails?.address?.street, [
          Validators.required,
        ]),
        zipCode: new FormControl(memberDetails?.address?.zipCode, [
          Validators.required,
        ]),
        city: new FormControl(memberDetails?.address?.city, [
          Validators.required,
        ]),
        // bankName: new FormControl(this.member?.bank?.name, [Validators.required]),
        // bankHolder: new FormControl(this.member?.bank?.holder, [Validators.required]),
        // iban: new FormControl(this.member?.bank?.iban, [Validators.required]),
        // ribAccountNumber: new FormControl(this.member?.bank?.ribAccountNumber, [Validators.required]),
        // ribKey: new FormControl(this.member?.bank?.ribKey, [Validators.required]),
        // ribBankCode: new FormControl(this.member?.bank?.ribBankCode, [Validators.required]),
        // ribBranchCode: new FormControl(this.member?.bank?.ribBranchCode, [Validators.required])
      });
    });
  }

  close() {
    this.modalCtrl.dismiss();
  }

  selectTab(tab: 'contract' | 'informations' | 'documents') {
    this.tab = tab;
  }

  async onMemberUpdate(type: 'email' | 'mobile' | 'phone') {
    let field = null;
    switch (type) {
      case 'email':
        field = 'mail';
        break;
      case 'mobile':
      case 'phone':
        field = type;
        break;
      default:
        return;
    }

    // Check if the field has been modified
    if (!this.informationsForm.get(field).dirty) {
      return;
    }

    const loading = await this.loadingCtrl.create({
      message: 'Mise à jour en cours',
    });
    await loading.present();

    this.populationService
      .updateMember(this.member.id, {
        type,
        value: this.informationsForm.get(field).value,
      })
      .then(async () => {
        await loading.dismiss();
      });
  }

  seeShare(share: Share) {
    this.close();
    this.modalService.openShareModal(share, () => {
      // return to the member modal
      this.modalService.createMemberModal(this.member, null, 'documents');
    });
  }

  openRadiationModal() {
    this.modalService.createRadiationModal(this.member, () => {
      // Close the member modal after successful radiation
      this.close();
    });
  }

  manageBeneficiaries() {
    this.close();
    this.navCtrl.navigateForward(
      `/dashboard/members/${this.member.id}/beneficiaries`,
    );
  }
}
